import { Injectable,Inject } from '@angular/core';
import { Title, Meta, MetaDefinition } from '@angular/platform-browser';
import { DOCUMENT } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class SeoService {

  constructor(@Inject(DOCUMENT) private dom:any,
  private title: Title, private meta: Meta) { }

  updateTitle(title: string){
    this.title.setTitle(title);
  }
  updateMetaTags(metaTags: MetaDefinition[]){
    //console.log("taggmetas",metaTags);
    metaTags.forEach(m=> this.meta.updateTag(m));
  }

  
  updateCanonicalUrl(url:string){
    const head = this.dom.getElementsByTagName('head')[0];
    var element: HTMLLinkElement= this.dom.querySelector(`link[rel='canonical']`) || null
    if (element==null) {
      element= this.dom.createElement('link') as HTMLLinkElement;
      head.appendChild(element);
      element.setAttribute('rel','canonical')
      element.setAttribute('href',url)
    }
    else{
      element.setAttribute('rel','canonical')
      element.setAttribute('href',url)
    }
  
  }

   
  updateImageSorce(url:string){
    const head = this.dom.getElementsByTagName('head')[0];
    var element: HTMLLinkElement= this.dom.querySelector(`link[rel='image_src']`) || null
    if (element==null) {
      element= this.dom.createElement('link') as HTMLLinkElement;
      head.appendChild(element);
      element.setAttribute('rel','image_src')
      element.setAttribute('href',url)
    }
    else{
      element.setAttribute('rel','image_src')
      element.setAttribute('href',url)
    }
  
  }
}
